import { useCallback, useEffect, useState } from 'react';
import * as publicContentApi from '../api/publicContentApi';
import { formatApiError } from '../utils/apiEnvelope';
import { normalizePublicPage } from '../utils/publicPageContent';

/**
 * Fetches public page JSON for a slug and language (refetches when either changes).
 * @param {string} slug e.g. "home"
 * @param {string} language e.g. "en" | "ar" | "ku"
 */
export function usePublicPageContent(slug, language) {
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    if (!slug) {
      setPage(null);
      setLoading(false);
      return;
    }
    setLoading(true);
    setError('');
    try {
      const data = await publicContentApi.fetchPublicPage(slug, language);
      setPage(normalizePublicPage(data));
    } catch (err) {
      setPage(null);
      setError(formatApiError(err, 'Could not load page content.'));
    } finally {
      setLoading(false);
    }
  }, [slug, language]);

  useEffect(() => {
    load();
  }, [load]);

  return { page, loading, error, reload: load };
}
